export default __webpack_public_path__ + "static/stadia-62737233332bd3de9d7f75581c670e85.png";